export function dateFormat(date, bool) {
  let newDate

  if (date) {
    let arr = date.split('-')
    let arrTime = date.split('T')
    let age
    if (bool) {
      newDate = arrTime[1].slice(0, 8) + ',' + ' ' + arr[2].slice(0, 2) + '-' + arr[1] + '-' + arr[0]
      return newDate
    }
    newDate = arr[2].slice(0, 2) + '-' + arr[1] + '-' + arr[0]

    age = Math.floor((new Date() - new Date(arr[0], arr[1] - 1, arr[2].slice(0, 2))) / 3600 / 1000 / 24 / 365.25)
    return {newDate, age}
  }
  return 'Нет данных'
}

export function reverseData(data) {
  if (data.indexOf('-') === 4) {
    data.split('-')
  }
  const newData = data.split('-').reverse().join('-')
  return newData
}



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/utils/helpers.js